(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
    (function() {
    var ft = document.querySelectorAll('.footer_tab');
    ft.forEach((t) => {
      t.addEventListener('click', function() {
        const section = this.getAttribute('data-section');
        const target = document.getElementById('tab_' + section);
        const isOpen = this.classList.contains('open');
        ft.forEach(el => {
          el.classList.remove('open');
          const sec = el.getAttribute('data-section');
          const link = document.getElementById('tab_' + sec);
          if (link) link.classList.remove('open_tab');
        });
        if (!isOpen) {
          this.classList.add('open');
          if (target) target.classList.add('open_tab');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-product-launch"] && !Shopify.designMode) return;
  try {
    

  class GoalProductSlider {

    constructor(section) {

      this.section = section;

      this.track =
        section.querySelector(
          '[data-goal-track]'
        );

      this.prev =
        section.querySelector(
          '[data-goal-prev]'
        );

      this.next =
        section.querySelector(
          '[data-goal-next]'
        );

      this.dotsContainer =
        section.querySelector(
          '[data-goal-dots]'
        );

      if (
        !this.track ||
        !this.prev ||
        !this.next ||
        !this.dotsContainer
      ) {
        return;
      }

      this.cards =
        Array.from(
          this.track.querySelectorAll(
            '.goal-product-card'
          )
        );

      if (this.cards.length <= 2) {
        return;
      }

      this.dots = [];

      this.scrollTimer = null;

      this.init();
    }


    init() {

      this.createDots();

      this.prev.addEventListener(
        'click',
        () => this.move(-1)
      );

      this.next.addEventListener(
        'click',
        () => this.move(1)
      );

      this.track.addEventListener(
        'scroll',
        () => {

          window.clearTimeout(
            this.scrollTimer
          );

          this.scrollTimer =
            window.setTimeout(
              () => this.update(),
              50
            );

        },
        {
          passive: true
        }
      );

      window.addEventListener(
        'resize',
        () => this.update()
      );

      this.update();
    }


    getStep() {

      if (!this.cards[0]) {
        return 0;
      }

      const styles =
        window.getComputedStyle(
          this.track
        );

      const gap =
        parseFloat(
          styles.columnGap ||
          styles.gap ||
          0
        );

      return (
        this.cards[0]
          .getBoundingClientRect()
          .width
        +
        gap
      );
    }


    getCurrentIndex() {

      const step =
        this.getStep();

      if (!step) {
        return 0;
      }

      return Math.max(
        0,
        Math.min(
          this.cards.length - 1,
          Math.round(
            this.track.scrollLeft /
            step
          )
        )
      );

    }


    getVisibleCards() {

      if (
        window.innerWidth <= 749
      ) {
        return 2;
      }

      return this.cards.length;

    }


    getMaxIndex() {

      return Math.max(
        0,
        this.cards.length -
        this.getVisibleCards()
      );

    }


    move(direction) {

      const step =
        this.getStep();

      if (!step) {
        return;
      }

      this.track.scrollBy({
        left:
          step *
          direction,

        behavior:
          'smooth'
      });

    }


    createDots() {

      this.dotsContainer.innerHTML =
        '';

      this.cards.forEach(
        (_, index) => {

          const dot =
            document.createElement(
              'span'
            );

          dot.className =
            'goal-products__dot';

          dot.dataset.index =
            index;

          this.dotsContainer
            .appendChild(dot);

        }
      );

      this.dots =
        Array.from(
          this.dotsContainer.children
        );

    }


    update() {

      const index =
        this.getCurrentIndex();

      const maxIndex =
        this.getMaxIndex();

      this.dots.forEach(
        (dot, dotIndex) => {

          dot.classList.toggle(
            'is-active',
            dotIndex === index
          );

        }
      );

      this.prev.disabled =
        index <= 0;

      this.next.disabled =
        index >= maxIndex;

    }

  }


  function initGoalProductSections() {

    document
      .querySelectorAll(
        '[id^="goal-products-"]'
      )
      .forEach(
        section => {

          if (
            section.dataset.sliderInitialised
          ) {
            return;
          }

          section.dataset.sliderInitialised =
            'true';

          new GoalProductSlider(
            section
          );

        }
      );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initGoalProductSections
    );

  } else {

    initGoalProductSections();

  }


  document.addEventListener(
    'shopify:section:load',
    initGoalProductSections
  );


  } catch(e) { console.error(e); }
})();
})();
